import React from 'react';
import './index.css';

const Loader = () => <div className="lds-ring"><div></div><div></div><div></div><div></div></div>;

export default Loader;
